import Skeleton from "react-loading-skeleton";
import { TabBarSkeleton } from "@/components/TabBarSkeleton";

/**
 * Full-page skeleton for the Settings route's pendingComponent.
 * Shows tab bar and the default Account tab form skeleton.
 */
export function SettingsPageSkeleton() {
	return (
		<div className="w-full">
			<TabBarSkeleton tabWidths={[70, 70, 100, 60]} />

			{/* Account tab skeleton */}
			<div className="mt-4 flex flex-col gap-8 max-w-2xl">
				{/* Change Password Section */}
				<section className="space-y-4">
					<Skeleton width={140} height={24} />
					<div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
						<div className="space-y-2">
							<Skeleton width={100} height={16} />
							<Skeleton height={38} borderRadius={8} />
						</div>
						<div className="space-y-2">
							<Skeleton width={130} height={16} />
							<Skeleton height={38} borderRadius={8} />
						</div>
					</div>
					<Skeleton width={130} height={36} borderRadius={8} />
				</section>

				<hr className="border-base-content/10" />

				{/* Change Email Section */}
				<section className="space-y-4">
					<Skeleton width={120} height={24} />
					<Skeleton width={200} height={16} />
					<div className="space-y-2">
						<Skeleton width={130} height={16} />
						<Skeleton height={38} borderRadius={8} />
					</div>
					<Skeleton width={120} height={36} borderRadius={8} />
				</section>
			</div>
		</div>
	);
}
